// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Tooltip = require("../../../reason/common/Tooltip.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;

function MyClientsWidgetComponents$HelperIcon(props) {
  let label = props.label;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(VisuallyHidden, {
        children: label
      }),
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(Tooltip.make, {
          label: label,
          children: JsxRuntime.jsx("span", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: props.icon,
              size: 17,
              className: "align-baseline inline-block text-gray-400"
            })
          })
        }),
        "aria-hidden": true
      })
    ]
  });
}

let HelperIcon = {
  make: MyClientsWidgetComponents$HelperIcon
};

function MyClientsWidgetComponents$HiddenAddressIcon(props) {
  return JsxRuntime.jsx(MyClientsWidgetComponents$HelperIcon, {
    label: "Hidden Address",
    icon: "lock"
  });
}

let HiddenAddressIcon = {
  make: MyClientsWidgetComponents$HiddenAddressIcon
};

function MyClientsWidgetComponents$AutoNotifyIcon(props) {
  return JsxRuntime.jsx(MyClientsWidgetComponents$HelperIcon, {
    label: "Auto-notify is on",
    icon: "bell"
  });
}

let AutoNotifyIcon = {
  make: MyClientsWidgetComponents$AutoNotifyIcon
};

exports.HelperIcon = HelperIcon;
exports.HiddenAddressIcon = HiddenAddressIcon;
exports.AutoNotifyIcon = AutoNotifyIcon;
/* IconV5 Not a pure module */
